import { render, staticRenderFns } from "./CollectionTable.vue?vue&type=template&id=744c3327&scoped=true"
import script from "./CollectionTable.vue?vue&type=script&lang=js"
export * from "./CollectionTable.vue?vue&type=script&lang=js"
import style0 from "./CollectionTable.vue?vue&type=style&index=0&id=744c3327&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744c3327",
  null
  
)

export default component.exports